import { StandardEvents } from '@shopify/events';

/**
 * Displays an installments message on the PDP.
 *
 * The installment amount is calculated server-side in Liquid
 * (blocks/product-installments-message.liquid). This element only refreshes the
 * displayed amount when the selected variant changes, mirroring the update
 * pattern used by product-price.js: it reads the re-rendered block from the
 * productSelect event payload instead of recomputing the value in JavaScript.
 */
class ProductInstallments extends HTMLElement {
  /** @param {import('@shopify/events').ProductSelectEvent} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newElement = html.querySelector(`product-installments[data-block-id="${this.dataset.blockId}"]`);
        if (!newElement) return;

        const newAmount = newElement.querySelector('[data-installment-amount]');
        const currentAmount = this.querySelector('[data-installment-amount]');
        if (newAmount && currentAmount) {
          currentAmount.textContent = newAmount.textContent;
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-installments] Event promise rejected:', error);
      });
  };

  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }
}

if (!customElements.get('product-installments')) {
  customElements.define('product-installments', ProductInstallments);
}
